export enum MentionType {
    contact = 'contact',
    doc = 'doc',
    group = 'group',
}
export enum MentionTypeNumber {
    contact = 5,
    group = 7,
}

export enum MentionFrom {
    content = 'content',
    comment = 'comment',
    onlineTodo = 'onlineTodo',
}
